import { create } from "zustand"

import {
  type Instruction,
  type InstructionSortField,
  InstructionsListDocument,
  type InstructionsListQuery,
  type SortingOrder,
} from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type InstructionSearchFilters = SearchFilters & {
  field?: InstructionSortField
  order?: SortingOrder
}

const deduplicateInstructions = (newData: Instruction[], existingData: Instruction[]): Instruction[] => {
  const uniqueIds = new Set(existingData.map((instruction) => instruction.instructionId))
  return [...existingData, ...newData.filter((instruction) => !uniqueIds.has(instruction.instructionId))]
}

export const useInstructionSearchStore = create(
  createSearchStore<Instruction, InstructionSearchFilters, InstructionsListQuery>({
    documentNode: InstructionsListDocument,
    deduplicateData: deduplicateInstructions,
    getQueryInput: (filters: InstructionSearchFilters, offset: number, limit: number) => {
      const { field, order, ...otherFilters } = filters
      return {
        filter: otherFilters,
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.instruction.list.__typename,
      data:
        data.instruction.list.__typename === "InstructionListSuccess"
          ? (data.instruction.list.instructions as Instruction[])
          : [],
      error: data.instruction.list.__typename === "InstructionFailure" ? data.instruction.list.error : undefined,
    }),
  })
)
